import styled from 'styled-components';
import colors from '../../../../helpers/colors';
import { NavItemLinkWithoutBorder, navItemSelectedBar } from '../styles';

export const NavItemLink = styled(NavItemLinkWithoutBorder)`
  ${navItemSelectedBar(colors.neutral06)}
`;
